import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useGetVacancyByIdQuery } from './api/vacanciesApi';
import VacancyDetail from './components/VacancyDetail';

const VacancyDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  const { data: vacancyData, isLoading, isError } = useGetVacancyByIdQuery(id || '');

  const handleClose = () => {
    setOpen(false);
    navigate('/vacancies');
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !vacancyData?.data) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Vacancy not found or error loading vacancy details.
        </Alert>
      </Box>
    );
  }

  return (
    <VacancyDetail
      open={open}
      onClose={handleClose}
      vacancy={vacancyData.data}
    />
  );
};

export default VacancyDetailPage;

